import Icons, { IconsProps } from '../Icons';

export default function (props: IconsProps) {
  return (
    <Icons {...props}>
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
        <path d="M17.225 8.775H18.775V7.225H17.225V8.775ZM17.225 12.775H18.775V11.225H17.225V12.775ZM17.225 16.775H18.775V15.225H17.225V16.775ZM16 20V19H21V5H11.375V7.2L10.375 6.475V4H22V20H16ZM2 20V11.5L8 7.225L14 11.5V20H9.275V15.5H6.725V20H2ZM3 19H5.725V14.5H10.275V19H13V12L8 8.5L3 12V19Z" />
      </svg>
    </Icons>
  );
}
